import {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import BaseAddressPicker from './address-picker/';

import debounce from 'debounce';

export default function wrapInput(InputType) {
  const StyledInputType = (props) => {
    return (
      <InputType
        {...props}
        className={`
          bg-[#fafafa] border border-border rounded-lg 
          font-roboto text-base mb-2 text-black font-light 
          placeholder-[#bababa] 
          sm:text-[70%] 
          ${props.className || ''}
        `}
      />
    );
  };

  return connect(
    undefined,
    undefined
  )(
    class TrackingTextInput extends Component {
      constructor(props) {
        super(props);
        this.trackInput = debounce(() => {}, 500);
      }

      static defaultProps = {
        trackValue: true,
        onChange: () => {},
        onKeyPress: () => {},
      };

      static propTypes = {
        name: PropTypes.string.isRequired,
        trackValue: PropTypes.bool,
        onChange: PropTypes.func,
        onKeyPress: PropTypes.func,
      };

      render() {
        const {className, onChange, trackValue, name, step, ...otherProps} = this.props;

        return (
          <StyledInputType
            className={className}
            data-cy={'input-value'}
            name={name}
            onChange={(value, label) => {
              this.trackInput({
                name,
                step,
                value: trackValue ? value : '(filtered)',
              });
              onChange(value, label);
            }}
            {...otherProps}
          />
        );
      }
    }
  );
}

export const PlainTextArea = wrapInput((props) => {
  const {...rest} = props;

  return <textarea {...rest} onChange={(e) => props.onChange(e.target.value)} />;
});

export const AddressPicker = wrapInput(BaseAddressPicker);
